// Consultation Status Component
// Displays consultation scheduling status

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar } from 'lucide-react';

const ConsultationStatus = ({ intake }) => {
  return (
    <Card className="border-slate-200" data-testid="consultation-status-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg" style={{ fontFamily: 'Manrope, sans-serif' }}>
          <Calendar className="w-5 h-5 text-teal-500" />
          Consultation
        </CardTitle>
      </CardHeader>
      <CardContent>
        {intake.consultation_scheduled ? (
          <div className="bg-teal-50 p-4 rounded-lg border border-teal-200">
            <p className="text-teal-800 font-semibold">Scheduled</p>
            <p className="text-teal-700 text-sm mt-1">{intake.consultation_date}</p>
          </div>
        ) : (
          <div className="bg-slate-50 p-4 rounded-lg border border-slate-200">
            <p className="text-slate-600">Not yet scheduled</p>
            <p className="text-slate-500 text-sm mt-1">Client has not booked a consultation</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ConsultationStatus;
